import React from 'react';
import styled from 'styled-components';
import { Switch, Route } from 'react-router-dom';
import { useProfile } from '../../../Contexts/UserProfileContext';
import { useAdvertisers } from '../../../Contexts/AdvertisersContext';
import AdvertiserInformation from './AdvertiserInformation';
import UpdatePaymentMethod from './UpdatePaymentMethod';
import ViewUsers from './ViewUsers';

const AdvertisersContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
`;

const ConnectedAdvertisers = () => {
    const { profile } = useProfile();

    const { advertisers, setShouldFetchAdvertiserData, setShouldFetchOtherData, currentAdvertiser, setCurrentAdvertiser } = useAdvertisers();

    return (
        <AdvertisersContainer>
            <Switch>
                <Route path="/portal/advertiser/advertiserInformation">
                    <AdvertiserInformation
                        advertisers={advertisers}
                        setShouldFetchAdvertiserData={setShouldFetchAdvertiserData}
                        setShouldFetchOtherData={setShouldFetchOtherData}
                        currentAdvertiser={currentAdvertiser}
                        profile={profile}
                        setCurrentAdvertiser={setCurrentAdvertiser}
                    />
                </Route>
                <Route path="/portal/advertiser/UpdatePaymentMethod">
                    <UpdatePaymentMethod currentAdvertiser={currentAdvertiser} advertisers={advertisers} profile={profile} />
                </Route>
                <Route path="/portal/advertiser/viewUsers">
                    <ViewUsers advertisers={advertisers} profile={profile} />
                </Route>
            </Switch>
        </AdvertisersContainer>
    );
};

export default ConnectedAdvertisers;
